module.exports = __webpack_public_path__ + "media/images/countryrect/st-3024ec4d1108806e5cff1cf38935f778.svg";